"use strict";

exports.__esModule = true;
exports.isPathGroupActive = isPathGroupActive;
exports.usePathGroupActive = usePathGroupActive;
var _reactRouterDom = require("react-router-dom");
/**
 * Layout helper: true when location matches any of the given paths (RR6 has no path arrays on Route).
 */

function usePathGroupActive(paths, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$end = _ref.end,
    end = _ref$end === void 0 ? false : _ref$end;
  var location = (0, _reactRouterDom.useLocation)();
  var list = Array.isArray(paths) ? paths : [paths];
  return list.some(function (path) {
    return (0, _reactRouterDom.matchPath)({
      path: path,
      end: end
    }, location.pathname) != null;
  });
}
function isPathGroupActive(pathname, paths, _temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    _ref2$end = _ref2.end,
    end = _ref2$end === void 0 ? false : _ref2$end;
  var list = Array.isArray(paths) ? paths : [paths];
  return list.some(function (path) {
    return (0, _reactRouterDom.matchPath)({
      path: path,
      end: end
    }, pathname) != null;
  });
}